

import { computed, defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import Container from '@/components/form/container/Container.vue'
import { useStore } from '@/store'
import { PaymentExternalUpdateModel } from '@/model/paymentSlip/paymentSlipModel'
// import { ElMessage } from 'element-plus'
import { paymentReceiptFileUpload } from '@/apis/paymentSlip/paymentSlip'
import { formatDate, formatThousands } from '@/utils'
import networkConfig from '@/config/default/net.config'
import { ElMessage } from 'element-plus'
import { CompanyListParamModel } from '@/model/master-data/companyModel'
import { getCompanyAllList } from '@/apis/main-data/company'
// import { UploadFilled } from '@element-plus/icons-vue'

export default defineComponent({
  name: 'VitroPayDialog',
  methods: { formatThousands },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    groupedSapList: {
      type: Array as () => number[],
      required: true,
      default: []
    },
    confirmText: {
      type: String,
      default: 'message.confirm'
    },
    cancelText: {
      type: String,
      default: 'message.cancel'
    },
    vitroData: {
      type: Object,
      required: true
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: { Container },
  emits: ['update:modelValue', 'update:vitroData', 'refresh'],
  setup(props, context) {
    const { t } = useI18n()
    const selectedDate = ref()
    const purposeInputValue = ref()
    const commentInputValue = ref()
    const updateUpload = ref()
    const uploadFile = ref()
    const externalPaymentUpload = ref()
    const companyCodeValue = ref()
    const dataInfo = ref<Object>(
      props.vitroData
    )
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const handleDownload = () => {
      console.log('handleDownload')
    }
    const handleCancel = () => {
      dialogVisible.value = false
    }
    const dataMap = reactive({
      BatchAddFile: [],
      companyCodeOptions: Array<string>(),
      getUploadUri() {
        return paymentReceiptFileUpload()
      },
      getUploadHeader() {
        return { Authorization: useStore().state.user.token }
      },
      async getCompanyCodes() {
        const params: CompanyListParamModel = {
          companyCode: null,
          name: null
        }
        const companyData = await getCompanyAllList(params)
        if (companyData?.data && companyData.data.length > 0) {
          companyData.data.forEach(item => {
            dataMap.companyCodeOptions.push(item.companyCode)
          })
          // dataMap.companyCodeOptions = companyData.data ?? []
        }
      }
    })
    const handleUpload = (files: any) => {
      dataMap.BatchAddFile = files.raw
    }
    const handleExceed = (files: any) => {
      uploadFile.value.clearFiles()
      const file = files[0]
      dataMap.BatchAddFile = file
      uploadFile.value.handleStart(file)
    }
    const handleConfirmPay = async() => {
      const params: PaymentExternalUpdateModel = {
        id: props.vitroData.id,
        companyCode: companyCodeValue.value,
        paymentDate: formatDate(selectedDate.value),
        purpose: purposeInputValue.value,
        comments: commentInputValue.value,
        paymentReceipt: updateUpload.value,
        file: dataMap.BatchAddFile
      }
      console.log(params)
      const formData = new FormData() as any
      formData.append('id', props.vitroData.id)
      formData.append('companyCode', companyCodeValue.value)
      formData.append('paymentDate', formatDate(selectedDate.value))
      formData.append('purpose', purposeInputValue.value)
      formData.append('comments', commentInputValue.value)
      formData.append('paymentReceipt', updateUpload.value)
      formData.append('file', dataMap.BatchAddFile)
      fetch(networkConfig.host + '/base/payment/slip/external/pay', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: useStore().state.user.token
        }
      }).then(response => {
        if (!response.ok) {
          ElMessage({
            message: 'Network response was not ok',
            type: 'error',
            duration: 2000
          })
        } else {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
          response.json()
          dialogVisible.value = false
          context.emit('refresh')
        }
      })
        .then(result => console.log(result))
        .catch(error => {
          ElMessage({
            message: error,
            type: 'error',
            duration: 2000
          })
        })
    }
    onMounted(() => {
      selectedDate.value = props.vitroData.paymentDate
      purposeInputValue.value = props.vitroData.purpose
      commentInputValue.value = props.vitroData.comments
      updateUpload.value = props.vitroData.paymentReceipt?.slice(props.vitroData.paymentReceipt.lastIndexOf('/') + 1)
      companyCodeValue.value = props.vitroData.companyCode
      dataMap.getCompanyCodes()
    })
    return {
      t,
      dialogVisible,
      dataInfo,
      selectedDate,
      purposeInputValue,
      commentInputValue,
      updateUpload,
      uploadFile,
      externalPaymentUpload,
      companyCodeValue,
      handleDownload,
      handleUpload,
      handleCancel,
      handleConfirmPay,
      handleExceed,
      ...toRefs(dataMap)
    }
  }
})
